import { render, staticRenderFns } from "./PccOrderProperties.vue?vue&type=template&id=f554f3e4&scoped=true&"
import script from "./PccOrderProperties.vue?vue&type=script&lang=js&"
export * from "./PccOrderProperties.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f554f3e4",
  null
  
)

export default component.exports